import { ComponentProps } from 'react';
import { bordColorTheme } from '../../../../styles/styles.constants';

const BordFiltersIcon = (props: ComponentProps<'svg'>) => {
  const { stroke, fill, ...rest } = props;
  return (
    <svg width={14} height={14} fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M12.248 4.743c-1.543-1.736-2.61-2.574-4.145-3.616a1.967 1.967 0 0 0-2.207 0C4.36 2.17 3.294 3.007 1.75 4.743M12.248 9.257c-1.543 1.736-2.61 2.574-4.145 3.616a1.967 1.967 0 0 1-2.207 0C4.36 11.83 3.294 10.992 1.75 9.257"
        stroke={stroke || bordColorTheme.primary.fgDefault}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BordFiltersIcon;
